import { DuviCoreAdminAppShell } from "../../components/duvi-core-admin-app-shell";
import { useDuviCoreAdminDashboard } from "./use-duvi-core-admin-dashboard";
import { DuviCoreAdminDashboardView } from "./duvi-core-admin-dashboard-view";

export function DuviCoreAdminDashboard() {
  const { kpis, recentAudit, nicheHealth, generatedAt, navigate } =
    useDuviCoreAdminDashboard();

  return (
    <DuviCoreAdminAppShell
      title="Dashboard"
      subtitle="Platform overview"
      breadcrumbs={["Dashboard"]}
      activeMenuItem="Dashboard"
    >
      <DuviCoreAdminDashboardView
        kpis={kpis}
        recentAudit={recentAudit}
        nicheHealth={nicheHealth}
        generatedAt={generatedAt}
        onNavigate={navigate}
      />
    </DuviCoreAdminAppShell>
  );
}
